import SectionKicker from './SectionKicker';

/**
 * PorQueImporta — el bloque «Por qué importa» que cierra el cuerpo de las
 * cuatro páginas de Producto antes de las FAQ.
 *
 * Dos variantes en el diseño, y otra vez la diferencia es una sola cosa: si hay
 * una cifra grande a la izquierda o no. `cifra` la decide.
 *
 * La cifra va en un `<p>` y no en un `<div>` suelto porque es el dato que
 * sostiene el titular de al lado; su pie la explica y los dos se leen juntos.
 */
export default function PorQueImporta({ kicker, cifra, cifraPie, titulo, parrafos, tonoCifra = 'gold' }) {
  const colorCifra = tonoCifra === 'red' ? 'text-v3-red' : 'text-v3-golddeep';

  return (
    <section className="px-6 pt-[76px]">
      <div className="max-w-[1180px] mx-auto">
        <SectionKicker>{kicker}</SectionKicker>

        <div className="bg-v3-surface rounded-3xl p-7 sm:p-10 mt-7 flex flex-wrap gap-8 lg:gap-12 items-center">
          {cifra ? (
            <div className="flex-none w-full sm:w-[200px]">
              <p className={`text-[56px] lg:text-[68px] font-bold tracking-[-.04em] leading-none ${colorCifra}`}>
                {cifra}
              </p>
              <p className="text-sm text-v3-muted mt-2 max-w-[22ch]">{cifraPie}</p>
            </div>
          ) : null}

          <div className="flex-1 min-w-[280px]">
            <h2 className="text-[26px] md:text-[31px] leading-[1.15] tracking-[-.025em] font-bold text-v3-ink max-w-[26ch]">
              {titulo}
            </h2>
            {parrafos.map((p, i) => (
              <p
                key={p}
                /* El último párrafo es el remate: va en tinta plena y en
                   negrita, como en el diseño. */
                className={`text-base leading-[1.7] mt-4 max-w-[62ch] ${
                  i === parrafos.length - 1 && parrafos.length > 1
                    ? 'text-v3-ink font-semibold'
                    : 'text-v3-body'
                }`}
              >
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
